import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const SubscriptionIncludesModal = ({ data }) => {
  return (
    <Flex
      flexDirection={["column", null, null, "row"]}
      className="border border-nova-transparency-black-20 rounded"
    >
      {data.items.map((item, index) => {
        const Icon = item.image
        return (
          <Box
            key={item.heading}
            width={[1, 1, 1, 1 / 3]}
            p={[16, 16, 24]}
            className={
              index + 1 !== data.items.length
                ? "border-b md:border-r md:border-b-0 border-nova-transparency-black-20"
                : ""
            }
          >
            <Flex
              mb={[16, 16, 24]}
              flexDirection={["row", null, null, "column"]}
              alignItems={["center", null, null, "flex-start"]}
            >
              <Box
                width={32}
                height={32}
                mr={[16, 16, 16, 0]}
                mb={[0, 0, 0, 16]}
              >
                <Icon width="100%" height="100%" />
              </Box>
              <Box flex="1">
                <TextElementNova
                  text={item.modalHeading}
                  className="Body-30-Dia-Strong"
                />
              </Box>
            </Flex>
            <TextElementNova
              text={item.modalText}
              className="Body-20-Dia-Normal"
            />
          </Box>
        )
      })}
    </Flex>
  )
}

export default SubscriptionIncludesModal
